import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../Components/GlobalNotification';

export const RoleBasedRoute = (props) => {
  const { showNotification } = useNotification();
  const { Components, allowedRoles } = props;
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get user data from localStorage
    const userInfo = localStorage.getItem('userInfo');
    const loginToken = localStorage.getItem('login');

    if (!loginToken) {
      // No login token, redirect to login
      navigate('/login');
      return;
    }

    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        setUserData(user);
        
        // Check if user role is in allowed roles
        if (allowedRoles.includes(user.role)) {
          setIsAuthorized(true);
        } else {
          // User doesn't have required role
          showNotification({ type: 'error', title: 'Error', message: 'You do not have permission to access this page' });
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Error parsing user info:', error);
        showNotification({ type: 'error', title: 'Error', message: 'Invalid user data' });
        navigate('/login');
      }
    } else {
      // No user info, redirect to login
      navigate('/login');
    }
    
    setIsLoading(false);
  }, [allowedRoles, navigate]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthorized) {
    return null; // Will redirect in useEffect
  }

  return <Components />;
};



